import { render, staticRenderFns } from "./OverviewGriya.vue?vue&type=template&id=264c2c0b"
import script from "./OverviewGriya.vue?vue&type=script&lang=js"
export * from "./OverviewGriya.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports